module.exports = __webpack_public_path__ + "img/euro_fill.1bdf9629.svg";